import React from 'react';
import TextField from './TextField';

// Convenience wrapper so callers can write <TextareaField /> instead of
// <TextField textarea rows={...} />. Keeps the JSX intent obvious.
export default function TextareaField(props) {
  return (
    <TextField
      textarea
      {...props}
    />
  );
}
